import React, {useState} from 'react';

import {PredictionsOptionViewModel} from "../../../../../domain/full-game/models/prediction/predictions.option.view-model";
import {PredictionOptionButton} from "./prediction.option-button";
import {PREDICTION_ANIMATION_ARGS} from "../../../../consts";
import classNames from "classnames";
import styles from "../../style/prediction.module.scss";

export const PredictionVoting = ({prediction, onVoteClick}) => {
  const [animationRunning, setAnimationRunning] = useState(false);
  const {enableVoting, options} = prediction;

  const onClick = (option) => {
    setAnimationRunning(true);
    setTimeout(() => onVoteClick && onVoteClick(option), PREDICTION_ANIMATION_ARGS.onClickDelay);
  }

  const optionProps = {
    animationRunning,
    onClick,
  }

  return (
    enableVoting ? <div className={classNames(styles.voting)}>
      {
        options.map((option: PredictionsOptionViewModel) => <PredictionOptionButton key={option.num}
                                                                                    option={option}
                                                                                    {...optionProps}/>)
      }
    </div> : null
  )
}
